import ManageGroupsContainer from './ManageGroupsContainer';

export default ManageGroupsContainer;